import { IGetAllDisciplinasArquivosUseCase } from "../../../presentation/useCases/read/get_all_disciplinas_arquivos_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { GetAllDisciplinasArquivosDaoModel, GetAllDisciplinasArquivosRequestModel } from "../../models/disciplina_arquivo_models";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * GetAllDisciplinasArquivosUseCase
 */

export class GetAllDisciplinasArquivosUseCase
  extends BasePaginatedUseCase<GetAllDisciplinasArquivosDaoModel>
  implements IGetAllDisciplinasArquivosUseCase
{
  constructor(private readonly repository: IProjetosRepository) {
    super();
  }

  async getAllDisciplinasArquivos(request: GetAllDisciplinasArquivosRequestModel): Promise<void> {
    const response = await this.repository.getAllDisciplinaArquivos(request);

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
